const API_CONFIG = {
  // Properly construct base URL with /api suffix
  BASE_URL: (() => {
    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080';
    // Ensure the URL ends with /api for consistent behavior
    return baseUrl.endsWith('/api') ? baseUrl : `${baseUrl}/api`;
  })(),
  
  // Remove API_PREFIX since it's now included in BASE_URL
  TIMEOUT: 30000,
  
  HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  
  ENDPOINTS: {
    // Auth endpoints
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    REFRESH_TOKEN: '/auth/refresh',
    
    // User endpoints
    USERS: '/users',
    CURRENT_USER: '/users/current',
    
    // Product endpoints
    PRODUCTS: '/products',
    PRODUCT_CATEGORIES: '/product-categories',
    PRODUCT_UNITS: '/product-units',
    TAX_RATES: '/tax-rates',
    
    // Customer endpoints
    CUSTOMERS: '/customers',
    
    // Supplier endpoints
    SUPPLIERS: '/suppliers',
    
    // Location endpoints
    LOCATIONS: '/locations',
    
    // Sales endpoints
    SALES_ORDERS: '/sales-orders',
    SALES_RETURNS: '/sales-returns',
    
    // Purchase endpoints
    PURCHASE_ORDERS: '/purchase-orders',
    PURCHASE_RETURNS: '/purchase-returns',
    
    // Report endpoints
    REPORTS: '/reports',
    SALES_REPORT: '/reports/sales',
    PURCHASE_REPORT: '/reports/purchases',
    INVENTORY_REPORT: '/reports/inventory',
    STOCK_REPORT: '/reports/stock',
    DAY_CLOSE_REPORT: '/reports/day-close',
    LOW_STOCK_REPORT: '/reports/low-stock',
    INVOICE_PROFIT_LOSS_REPORT: '/reports/invoice-profit-loss',
    TOP_SELLING_PRODUCTS_REPORT: '/reports/top-selling-products',
    
    // Billing endpoints
    BILLING_REPORT_BY_DATE: '/reports/billing/by-date',
    BILLING_REPORT_BY_MONTH: '/reports/billing/by-month',
    
    // Credit endpoints
    CUSTOMER_CREDIT: '/customer-credit',
    CUSTOMER_TRANSACTIONS: '/customer-credit/transactions',
    
    // Notification endpoints
    NOTIFICATIONS: '/notifications',
    MARK_NOTIFICATION_READ: '/notifications/mark-read',
    MARK_ALL_NOTIFICATIONS_READ: '/notifications/mark-all-read',
    UNREAD_NOTIFICATIONS_COUNT: '/notifications/unread-count',
    
    // Receipt endpoints
    RECEIPT: '/receipts',
    
    // Dashboard endpoints
    DASHBOARD_SALES_CHART: '/dashboard/sales-chart',
    DASHBOARD_INVENTORY_CHART: '/dashboard/inventory-chart',
    DASHBOARD_REVENUE_TREND: '/dashboard/revenue-trend',
    DASHBOARD_TOP_CATEGORIES: '/dashboard/top-categories',
    
    // SaaS Tenant Management endpoints
    TENANTS: '/tenants',
    TENANT_REGISTER: '/tenants/register',
    TENANT_STATISTICS: '/tenants/{id}/statistics',
    TENANT_SETTINGS: '/tenants/{id}/settings',
    CHECK_SUBDOMAIN: '/tenants/check-subdomain',
    EXPIRING_TRIALS: '/tenants/expiring-trials',
    
    // SaaS Subscription Management endpoints
    SUBSCRIPTION_PLANS: '/subscriptions/plans',
    SUBSCRIPTION_CURRENT: '/subscriptions/current',
    SUBSCRIPTION_HISTORY: '/subscriptions/history',
    SUBSCRIPTION_START_TRIAL: '/subscriptions/start-trial',
    SUBSCRIPTION_CONVERT_TRIAL: '/subscriptions/convert-trial',
    SUBSCRIPTION_CHANGE_PLAN: '/subscriptions/change-plan',
    SUBSCRIPTION_CANCEL: '/subscriptions/cancel',
    SUBSCRIPTION_EXTEND_TRIAL: '/subscriptions/extend-trial',
    SUBSCRIPTION_TRIAL_STATUS: '/subscriptions/trial-status',
    SUBSCRIPTION_STATISTICS: '/subscriptions/statistics',
    SUBSCRIPTION_REVENUE_METRICS: '/subscriptions/revenue-metrics',
    
    // SaaS Usage Management endpoints
    USAGE_SUMMARY: '/usage/summary',
    USAGE_LIMITS: '/usage/limits',
    USAGE_HISTORY: '/usage/history',
    USAGE_VALIDATE: '/usage/validate',
    USAGE_ANALYTICS: '/usage/analytics',
    
    // Super Admin endpoints
    SUPER_ADMIN: '/superadmin',
    
    // Print Settings endpoints
    PRINT_SETTINGS: '/print-settings',
    
    // Custom Print Templates endpoints
    CUSTOM_PRINT_TEMPLATES: '/custom-print-templates',

    // Barcode/QR label settings
    BARCODE_SETTINGS: '/barcode-settings'
  }
};

export default API_CONFIG; 